export const EDIT_FORM_TEXTS = {
  ALL_FIELDS_MUST_HAVE_NAME: 'У всех полей должно быть заполнено название!',
  UPDATE_SUCCESS: 'Форма успешно обновлена!',
  UPDATE_ERROR: 'Упс! Что-то пошло не так',
  NOT_FILLED_FORMULAS: 'Пожалуйста, заполните все формулы',
  UNSAVED_FIELDS: 'Пожалуйста, сохраните все поля',
};
